var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekAutocomplete, PeekInput } from "@piiqtechnologies/ui-components";
import { useCommunities, useDebounce, useError, useLoader } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
export function CommunitySelectorAutocomplete(_a) {
    var { form, field } = _a, props = __rest(_a, ["form", "field"]);
    const [searchKey, setSearchKey] = useState();
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [getCommunities, communities, communitiesLoading, communitiesError] = useCommunities();
    const { setLoader } = useLoader();
    const { setError } = useError();
    useEffect(() => {
        getCommunities({
            limit: 100,
            name: debouncedSearchKey || undefined,
        });
    }, [debouncedSearchKey]);
    useEffect(() => {
        setLoader(communitiesLoading, "communitiesLoading");
        return () => setLoader(false, "communitiesLoading");
    }, [communitiesLoading]);
    useEffect(() => {
        if (communitiesError)
            setError(communitiesError === null || communitiesError === void 0 ? void 0 : communitiesError.message);
    }, [communitiesError]);
    const handleCommunitySelection = (_event, item) => {
        const value = Object.assign({}, item);
        delete value.organization;
        form.setFieldValue(field.name, value);
    };
    const options = useMemo(() => {
        var _a;
        if (!(communities === null || communities === void 0 ? void 0 : communities.data))
            return [];
        return (_a = communities.data) === null || _a === void 0 ? void 0 : _a.filter(({ name }) => !searchKey || name.match(new RegExp(searchKey, "i"))).map(({ _id, name, organization }) => ({ id: _id, name, organization }));
    }, [communities === null || communities === void 0 ? void 0 : communities.data, searchKey]);
    return (React.createElement(PeekAutocomplete, { freeSolo: false, clearIcon: null, popupIcon: null, onChange: handleCommunitySelection, options: (options === null || options === void 0 ? void 0 : options.length) ? options : [], getOptionLabel: ({ name, organization }) => `${name} (${organization === null || organization === void 0 ? void 0 : organization.name})`, sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, value: options.find((option) => { var _a; return option.id === ((_a = field.value) === null || _a === void 0 ? void 0 : _a.id); }), isOptionEqualToValue: (option, value) => option.id === (value === null || value === void 0 ? void 0 : value.id), renderInput: (params) => (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: searchKey, onChange: (e) => setSearchKey(e.target.value) }), form: form }, params, props, { InputLabelProps: { required: true }, InputProps: Object.assign({}, params.InputProps) }))) }));
}
